import { ErrorInfo } from "../types";
import { DebugInfo } from "./DebugInfo";
import { ErrorCause } from "./ErrorCause";
import { ErrorMessage } from "./ErrorMessage";
import { ErrorTypeInfo } from "./ErrorTypeInfo";
import { RawErrorData } from "./RawErrorData";
import { StackTrace } from "./StackTrace";

type DevDetailsProps = {
  error: unknown;
  status?: number;
  isDev: boolean;
  devErrorInfo: ErrorInfo | null;
};

const NO_ERROR_MESSAGE =
  "No error information available. This might happen if the error was not properly passed to the ErrorPage component.";

export function DevDetails({
  error,
  status,
  isDev,
  devErrorInfo,
}: DevDetailsProps) {
  if (!isDev) {
    return null;
  }

  return (
    <div className="mt-12 space-y-6 rounded-lg border-2 border-red-200 bg-red-50 p-6 text-left">
      <div className="border-b border-red-200 pb-3">
        <h3 className="text-lg font-bold text-red-900">
          🐛 Developer Error Details
        </h3>
        <p className="mt-1 text-sm text-red-700">
          This information is only visible in development mode.
        </p>
      </div>

      <DebugInfo error={error} status={status} isDev={isDev} />

      {devErrorInfo ? (
        <>
          <ErrorTypeInfo errorInfo={devErrorInfo} />
          <ErrorMessage errorInfo={devErrorInfo} />
          <ErrorCause errorInfo={devErrorInfo} />
          <StackTrace errorInfo={devErrorInfo} />
          <RawErrorData errorInfo={devErrorInfo} />
        </>
      ) : (
        <div className="rounded bg-white p-4 text-center">
          <p className="text-sm text-gray-600">{NO_ERROR_MESSAGE}</p>
        </div>
      )}
    </div>
  );
}
